
import {
  Directive,
  ElementRef,
  HostListener,
  Renderer2,
  forwardRef
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR
} from '@angular/forms';

@Directive({
  selector: 'input[appCurrencyMask]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CurrencyMaskDirective),
      multi: true
    }
  ]
})
export class CurrencyMaskDirective implements ControlValueAccessor {
  private el: HTMLInputElement;
  private onChange: (value: number | null) => void = () => {};
  private onTouched: () => void = () => {};
  private fractionDigits = 2; // centavos

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {
    const native = this.elementRef.nativeElement;
    if (!(native instanceof HTMLInputElement)) {
      throw new Error('appCurrencyMask deve ser aplicada em um <input>.');
    }
    this.el = native;
  }

  // Usuário digitou
  @HostListener('input')
  onInput(): void {
    const raw = this.el.value;
    const digits = raw.replace(/\D/g, '');
    if (!digits) {
      this.render('');
      this.onChange(null);
      return;
    }
    // Converte dígitos para número com 2 casas (centavos)
    const numeric = Number(digits) / Math.pow(10, this.fractionDigits);
    const safe = Math.max(0, numeric);
    this.renderCurrency(safe);
    this.onChange(safe); // envia número para o FormControl
  }

  @HostListener('blur')
  onBlur(): void {
    this.onTouched();
    const num = this.parseToNumber(this.el.value);
    if (num === null) {
      // opcional: definir zero ao sair do campo
      this.renderCurrency(0);
      this.onChange(0);
    } else {
      this.renderCurrency(num);
    }
  }

  // ControlValueAccessor: recebe valor programaticamente via setValue/patchValue
  writeValue(value: number | string | null): void {
    if (value === null || value === undefined || value === '') {
      this.render('');
      return;
    }
    const num = typeof value === 'number' ? value : this.parseToNumber(value);
    if (num === null) {
      this.render('');
    } else {
      this.renderCurrency(num); // <-- aqui formata 1000520.00 como R$ 1.000.520,00
    }
  }

  registerOnChange(fn: (value: number | null) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.renderer.setProperty(this.el, 'disabled', isDisabled);
  }

  // Helpers
  private render(value: string): void {
    this.renderer.setProperty(this.el, 'value', value);
  }

  private renderCurrency(value: number): void {
    const formatted = value.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: this.fractionDigits,
      maximumFractionDigits: this.fractionDigits
    });
    this.render(formatted);
  }

  private parseToNumber(input: string): number | null {
    if (!input) return null;
    // Remove tudo exceto dígitos e vírgula, troca vírgula por ponto
    const cleaned = input.replace(/[^\d,]/g, '').replace(',', '.');
    const num = parseFloat(cleaned);
    return isNaN(num) ? null : num;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directive/CurrencyMaskDirective.ts